<template>
  <div class="column has-text-centered">
    <b-icon
      icon="chalkboard-teacher"
      :style="{ color: lessonIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span :style="{ color: lessonIsActive ? 'black' : '#d1d1d1' }">
      Aula
    </span>
  </div>
</template>

<script>
export default {
  props: ["lessonIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
